// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loaderContainer {background: rgba(0, 0, 0, 0.7); position: fixed; left:0; right:0; bottom:0; top:0; z-index: 8000;}
:host ::ng-deep .mat-progress-spinner circle, .mat-spinner circle {   
    stroke: #ff004f;
}
.loaderCell {display: table; width: 100%; height: 100%;}
.loaderCellInner {display: table-cell; vertical-align: middle;}
.loaderElement {width: 75px; margin: 0 auto;}

.loading-text{
    color: white;
    font-size: 20px;
    font-weight: 600;
    text-align: center;
    margin-top: 10px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/UI/spinner/spinner.component.css"],"names":[],"mappings":"AAAA,kBAAkB,8BAA8B,EAAE,eAAe,EAAE,MAAM,EAAE,OAAO,EAAE,QAAQ,EAAE,KAAK,EAAE,aAAa,CAAC;AACnH;IACI,eAAe;AACnB;AACA,aAAa,cAAc,EAAE,WAAW,EAAE,YAAY,CAAC;AACvD,kBAAkB,mBAAmB,EAAE,sBAAsB,CAAC;AAC9D,gBAAgB,WAAW,EAAE,cAAc,CAAC;;AAE5C;IACI,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;AACpB","sourcesContent":[".loaderContainer {background: rgba(0, 0, 0, 0.7); position: fixed; left:0; right:0; bottom:0; top:0; z-index: 8000;}\n:host ::ng-deep .mat-progress-spinner circle, .mat-spinner circle {   \n    stroke: #ff004f;\n}\n.loaderCell {display: table; width: 100%; height: 100%;}\n.loaderCellInner {display: table-cell; vertical-align: middle;}\n.loaderElement {width: 75px; margin: 0 auto;}\n\n.loading-text{\n    color: white;\n    font-size: 20px;\n    font-weight: 600;\n    text-align: center;\n    margin-top: 10px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
